import React from "react";
import LazyLoad from "react-lazyload";
import isImage from "is-image";
import { TableRow, TableCell, Avatar, IconButton } from "@material-ui/core";
import {
  FolderOutlined as FolderIcon,
  MoreVert as MoreVertIcon,
  CreateNewFolder as CreateNewFolderIcon,
  Delete as RemoveIcon,
  CloudUpload as CloudUploadIcon,
  Close as CloseIcon,
  CheckCircleOutline as CheckIcon
} from "@material-ui/icons";
import { getDownloadURL } from "../../utils/files";

const FileRow = ({
  classes,
  file,
  selectedFiles,
  addFile,
  removeFile,
  setMenuContext,
  setShowDialog,
  rowCount
}) => {
  const isSelectedFile =
    selectedFiles && selectedFiles.find(f => f.fullPath == file.fullPath);

  return (
    <LazyLoad
      overflow
      height={73}
      // throttle={100}
      offset={73 * 3}
      placeholder={<TableRow style={{ height: 73 }} />}
    >
      <TableRow
        onClick={() =>
          isSelectedFile
            ? removeFile(file)
            : addFile({
                fullPath: file.fullPath,
                name: file.name,
                downloadURL: getDownloadURL(file.fullPath)
              })
        }
        row="checkbox"
        hover
        tabIndex={-1}
        key={file.name}
      >
        <TableCell align="center">{rowCount}</TableCell>

        <TableCell align="center">
          {isImage(file.name) ? (
            <div className={classes.preview}>
              <img src={getDownloadURL(file.fullPath)} />
            </div>
          ) : (
            <Avatar className={classes.avatar}>
              {file.name
                .split(".")
                .slice(-1)
                .pop() || "?"}
            </Avatar>
          )}
        </TableCell>
        <TableCell>{file.name} </TableCell>
        {selectedFiles && (
          <TableCell>{isSelectedFile && <CheckIcon />}</TableCell>
        )}
        <TableCell>File</TableCell>
        <TableCell align="right">
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            // onClick={handleAnchorEl({
            //   type: 'file',
            //   path: file.fullPath
            // })}
            onClick={e => {
              e.stopPropagation();
              setMenuContext({
                type: "file",
                path: file.fullPath,
                file
              });
              setShowDialog("deleteFile");
            }}
          >
            {/* <MoreVertIcon /> */}
            <RemoveIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </LazyLoad>
  );
};

export default FileRow;
